import { render, staticRenderFns } from "./dialog-2faotp.vue?vue&type=template&id=30275a40&scoped=true&"
import script from "./dialog-2faotp.vue?vue&type=script&lang=js&"
export * from "./dialog-2faotp.vue?vue&type=script&lang=js&"
import style0 from "./dialog-2faotp.vue?vue&type=style&index=0&id=30275a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30275a40",
  null
  
)

export default component.exports